import { StringContext } from "../../core/StringContext";
import { StringModule } from "../../core/StringModule";
import { StringObject } from "../../objects/StringObject";
import { styleTxn } from "../../utils/style-txn";

const getRandomInRange = (min: number, max: number): number => {
  const lo = Math.min(min, max);
  const hi = Math.max(min, max);
  return lo + Math.random() * (hi - lo);
};

const getRandomIntInRange = (min: number, max: number): number => {
  const lo = Math.ceil(Math.min(min, max));
  const hi = Math.floor(Math.max(min, max));
  if (hi < lo) return lo;
  return Math.floor(Math.random() * (hi - lo + 1)) + lo;
};

const normalizeRange = (value: unknown): [number, number] => {
  if (Array.isArray(value) && value.length >= 2) {
    const a = Number(value[0]);
    const b = Number(value[1]);
    if (Number.isFinite(a) && Number.isFinite(b)) return [a, b];
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return [0, value];
  }
  return [0, 1];
};

export class StringRandom extends StringModule {
  constructor(context: StringContext) {
    super(context);
    this.htmlKey = "random";
    this.attributesToMap.push({
      key: "random-number",
      type: "json",
      fallback: "[0,1]",
    });
    this.attributesToMap.push({
      key: "random-type",
      type: "string",
      fallback: "int",
    });
  }

  override onObjectConnected(object: StringObject): void {
    const el = object.htmlElement as HTMLElement;
    const range = normalizeRange(object.getProperty("random-number"));
    const type = String(object.getProperty("random-type") ?? "float").toLowerCase();
    const value =
      type === "int"
        ? getRandomIntInRange(range[0], range[1])
        : getRandomInRange(range[0], range[1]);

    styleTxn.run(() => {
      styleTxn.setVars(el, { "--random": value });
    });
  }
}
